/**
 * Below values relate to direction property of the
 */
var LABEL_DIRECTIONS = {
  top: "vertical",
  bottom: "verticalReverse",
  left: "horizontal",
  right: "horizontalReverse"
};
export default LABEL_DIRECTIONS;